import { Component, OnInit, ViewChild, enableProdMode, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { DxDataGridComponent, DxScrollViewComponent, DxDataGridModule, DxSelectBoxModule, DxCheckBoxModule, DxTemplateModule, DxTreeViewModule, DxDropDownBoxModule, DxTreeViewComponent } from 'devextreme-angular';
import { OperacionService } from '../../../services/formulacion/operacion.service';
import { PartidaPresService } from '../../../services/formulacion/partida-pres.service';
import { UnidadMedidaService } from '../../../services/formulacion/unidad-medida.service';
import { TareaDetalleService } from '../../../services/formulacion/tarea-detalle.service';
import { TareaService } from '../../../services/formulacion/tarea.service';
import { GeneralService } from '../../../services/formulacion/general.service';
import { OrganismoService } from '../../../services/formulacion/organismo.service';
import { FuenteService } from '../../../services/formulacion/fuente.service';
import { switchMap } from 'rxjs/operators';
import { UtilHelper } from '../../../_helpers/util';
import { IndicadorProgramacionService } from 'src/app/services/service.index';
declare var jQuery: any;
declare var toastr;

@Component({
  selector: 'app-list-tarea',
  templateUrl: './list-tarea.component.html',
  styleUrls: [],
  providers: [OperacionService, PartidaPresService, UnidadMedidaService, TareaDetalleService, TareaService, GeneralService, OrganismoService, FuenteService]
})
export class ListTareaComponent implements OnInit {

  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;
  @ViewChild(DxScrollViewComponent) scrollView: DxScrollViewComponent;

  treeDataSource: any[] = [
    { id: 2, descripcion: 'Licenciado' },
    { id: 3, descripcion: 'Técnico Superior' }
  ];
  
  insert: boolean = false;
  programacionTarea: any;
  treeBoxValue: string[];
  popupProgramacion: boolean;
  programacion: any = {};
  selectedItems: number[] = [];

  lbl_cantidad = 'Cantidad';
  accionEspId: string;
  poaTecho: any;
  operaciones: any = [];
  tareas: any = [];
  popupVisibleTA: boolean = false;
  popupVisibleDP: boolean = false;
  popupVisibleDel: boolean = false;
  popupVisibleETA: boolean = false;
  popupVisibleDelT: boolean = false;
  popupVisibleEPD: boolean = false;
  popupVisibleAFP: boolean = false;
  popupVisibleP: boolean = false;
  techoId: string;
  unidades: any = [];
  partidas: any = [];
  unidadMedida: any = [];
  detalle: any = {};
  accionEspecifica: any = {};
  excedeTotal: boolean = false;
  modelTarea: any = { id: 0, descripcion: '', operacion_id: 0 };
  fuentes: any = [];
  operacionId: number;
  tareasList: any = [];
  editDetalle: boolean = false;
  dOperacion = '';
  clicked: boolean = false;
  detalleId: number;
  tareaId: number;
  dataTDF: any = {};
  rol: number = 0;
  dataFuentes: any[];
  dataOrganismos: any[];
  modelAFP: any = {};
  textPartida: string = '';
  textPartidaId: number = 0;
  hasError: any = {};
  hasError2: any = {};
  hasError3: any = {};
  gestion = 0;
  op_id: number = 0;
  esConsultor: boolean = false;
  esConsultorL: boolean = false;
  escalas: any = [];
  consultoria: any = {};
  perfiles: any = [];
  ArrayPartidaConsultoriasL: number[] = [83, 92, 192, 195, 198,30];
  ArrayPartidaConsultoriasP: number[] = [82, 91, 191, 194, 197, 84];

  constructor(private route: ActivatedRoute, private router: Router, private _gs: GeneralService, private _ps: PartidaPresService, private _us: UnidadMedidaService,
    private _ts: TareaDetalleService, private _tt: TareaService, private _os: OperacionService, private _fs: FuenteService, private _oo: OrganismoService) {
    this.treeBoxValue = [''];

    this.route.paramMap.pipe(switchMap((params: ParamMap) => this.techoId = params.get('tid'))).subscribe();
    this.route.paramMap.pipe(switchMap((params: ParamMap) => this.accionEspId = params.get('id'))).subscribe();
    this.poaTecho = {
      'descripcion_techo': '',
      'techo_unidad_organizacional': '',
      'techo_categoria_programatica': '',
      'techo_tipo_gasto': '',
      'techo_tipo_intervencion': '',
      'techo_gestion': ''
    };
    this.getPoaTecho();
    this.getOperacionesAE();
    this._ps.getPartidaPres().subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) { this.partidas = result.data; }
      },
      (error) => { console.log('Error', error); });
    this._us.getUnidadMedidaActivo().subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) { this.unidadMedida = result.data; }
      },
      (error) => { console.log('Error', error); });
    this.resetErrors();
    this.resetErrors2();
    let u = JSON.parse(localStorage.getItem('u'));
    this.gestion = u.gestion;
    if (u != null) {
      this.rol = u.rol;
      if (this.rol == 23) {
        this.getFuentes();
        this.getOrganismos();
        this.resetModel();
        this.resetErrors3();
      }
    }
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    
  }

  getPoaTecho() {
    this._gs.getPoaTechoById(this.techoId).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.poaTecho = result.data;
        } else {
          this.poaTecho = [];
        }
      },
      (error) => { console.log('Error', error); });
  }

  getOperacionesAE() {
    let self = this;
    this._gs.getOperacionesByAE(this.accionEspId).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.operaciones = result.data;
         
          var sel = jQuery('<select>').prependTo('.dx-toolbar-before');
          sel.css({
            'border': '1px solid #ddd',
            'border-radius': '3px',
            'margin-right': '3px',
            'margin-top': '2px',
            'width': '300px',
            'padding': '6px'
          });
          sel.change(function () {
            self.changeOperaciones(jQuery(this).val());
            self.operacionId = jQuery(this).val();
            self.op_id = self.operacionId;
            //frank
            self._os.getUnidadesTechoByOperacionId(self.operacionId).subscribe(
              (response) => {
                let result = UtilHelper.responses(response);
                if (result.status == 200) { self.unidades = result.data; }
              },
              (error) => { console.log('Error', error); });
            self._os.getFuentesTechoByOperacionId(self.operacionId).subscribe(
              (response) => {
                let result = UtilHelper.responses(response);
                if (result.status == 200) { self.fuentes = result.data; }
              },
              (error) => { console.log('Error', error); });
            self._tt.getTareasByOperacionId(self.operacionId).subscribe(
              (response) => {
                let result = UtilHelper.responses(response);
                if (result.status == 200) { self.tareasList = result.data; }
              },
              (error) => { console.log('Error', error); });
            
          });
          sel.append(jQuery("<option>").attr('value', 0).prop({ 'disabled': true, 'selected': true }).text('Seleccione un Producto (Operación)'));
          jQuery.each(this.operaciones, function (index, mdata) {
            sel.append(jQuery("<option>").attr('value', mdata.id).text(mdata.descripcion));
          });
        } else {
          this.operaciones = [];
        }
      },
      (error) => {
        console.log('Error', error);
      });
  }

  onToolbarPreparing(e) {
    e.toolbarOptions.items.unshift({
      location: 'before',
      template: 'acciones'
    });
  }

  showModalAddTA() {
    this.dOperacion = this.operaciones.filter(o => o.id == this.operacionId).map(o => o.descripcion).toString();
    this.modelTarea.descripcion = '';
    this.popupVisibleTA = true;
  }

  hideModalTA() {
    this.popupVisibleTA = false;
  }

  showModalEditDT(id) {
    this.tareaId = id;
    this.resetErrors();
    this.getTareaDetalleById(id);
    this.editDetalle = true;
    this.popupVisibleDP = true;
  }

  showModalAddDP() {
    this.editDetalle = false;
    this.newTareaDetalle();
    this.getTareasByOperacionId();
    this.detalle.unidad_ejecutora_id = this.poaTecho.unidad_organizacional_id;
    this.popupVisibleDP = true;
  }

  hideModalDT() {
    this.popupVisibleDP = false;
  }

  showModalAFP(id) {
    this.modelAFP.id = id;
    this.popupVisibleAFP = true;
  }

  changeOperaciones(id: string) {
    this._ts.getTareasByAE(id).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.tareas = result.data.detalle;
          
        } else {
          this.tareas = [];
        }
      },
      (error) => {
        console.log('Error', error);
      });
  }

  getTareasByOperacionId() {
    this._tt.getTareasByOperacionId(this.operacionId).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) { this.tareasList = result.data; }
      },
      (error) => { console.log('Error', error); });
  }

  getDescripcionPartida(e: any) {
    this.detalle.descripcion_partida = this.partidas.filter(o => o.id == parseInt(e.value)).map(o => o.titulo).toString();
  }


  calculaCantidad() {
    let t = this.detalle.total == '' ? '0' : this.detalle.total;
    let p = this.detalle.precio_unitario == '' ? '1' : this.detalle.precio_unitario;
    let c = this.detalle.numero_items == '' ? '1' : this.detalle.numero_items;
    let existe = this.ArrayPartidaConsultoriasL.includes(this.detalle.partida_presupuestaria_id);
    let existe2 = this.ArrayPartidaConsultoriasP.includes(this.detalle.partida_presupuestaria_id);  


    if ((existe == true) || (existe2 == true)) {
      this.lbl_cantidad = 'Cantidad de Meses';

      let aux = ((parseFloat(t) / parseFloat(p)) / parseFloat(c));
      this.detalle.cantidad = (Math.floor(aux * Math.pow(10, 2)) / Math.pow(10, 2));
    }
    else {
      
      let aux2 = (parseFloat(t) / parseFloat(p));
      this.detalle.cantidad = (Math.floor(aux2 * Math.pow(10, 2)) / Math.pow(10, 2));
    }

    if (this.rol != 23) {
      if (parseFloat(t) > parseFloat(this.poaTecho.monto_total)) {
        toastr.warning('Sobrepasó el total del techo presupuestario.');
        this.excedeTotal = true;
      }
      else this.excedeTotal = false;
    }
  }

  getTareaDetalleById(id: number) {
    let dp: any;
    this._ts.getTareaDetallePresupuestoById(id).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.detalle = result.data;
          this.detalle.unidad_ejecutora_id = result.data.unidad_ejecutora_id;
          this.getCodigoPartida();
          
        }
      },
      (error) => { console.log('Error', error); });
  }

  calculaTotalFuente(id) {
    this.excedeTotal = false;
    let f = this.detalle.fuentes.filter(o => o.id == id).map(o => o)[0];
    let m1 = f.enero != '' ? parseFloat(f.enero) : 0;
    let m2 = f.febrero != '' ? parseFloat(f.febrero) : 0;
    let m3 = f.marzo != '' ? parseFloat(f.marzo) : 0;
    let m4 = f.abril != '' ? parseFloat(f.abril) : 0;
    let m5 = f.mayo != '' ? parseFloat(f.mayo) : 0;
    let m6 = f.junio != '' ? parseFloat(f.junio) : 0;
    let m7 = f.julio != '' ? parseFloat(f.julio) : 0;
    let m8 = f.agosto != '' ? parseFloat(f.agosto) : 0;
    let m9 = f.septiembre != '' ? parseFloat(f.septiembre) : 0;
    let m10 = f.octubre != '' ? parseFloat(f.octubre) : 0;
    let m11 = f.noviembre != '' ? parseFloat(f.noviembre) : 0;
    let m12 = f.diciembre != '' ? parseFloat(f.diciembre) : 0;
    let t = m1 + m2 + m3 + m4 + m5 + m6 + m7 + m8 + m9 + m10 + m11 + m12;
    let tt = 0;
    for (var i = 0; i < this.detalle.fuentes.length; i++) {
      if (this.detalle.fuentes[i].id == id) {
        this.detalle.fuentes[i].monto = t;
      }
      tt += parseFloat(this.detalle.fuentes[i].monto);
    }
    if (Number(tt.toFixed(2)) > parseFloat(this.detalle.total)) {
      this.excedeTotal = true;
      toastr.warning('Sobrepasó el total del presupuesto de la tarea.');
    }
  }

  saveTarea() {
    let data = { operacion_id: this.operacionId, id: this.modelTarea.id, descripcion: this.modelTarea.descripcion };
    if (this.modelTarea.id == 0) {
      this.clicked = true;
      this._tt.postTarea(data).subscribe(
        response => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.refreshDataGrid();
            this.hideModalTA();
            this.getTareasByOperacionId();
            toastr.success('Actividad (Tarea) registrada correctamente, se visualizará en el Formulario 2');
            this.clicked = false;
          }
        },
        (error) => { console.log('Error', error); });
    }
  }

  getTareaById(id: number) {
    this._tt.getTareaById(id).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.modelTarea = result.data;
        }
      },
      (error) => { console.log('Error', error); });
  }

  newTareaDetalle() {
    let f = []; let i = 1;
    this.fuentes.forEach(item => {
      f.push({ id: i, fuente_id: item.fuente_id, organismo_id: item.organismo_id, fuente_sigla: item.fuente_sigla, organismo_sigla: item.organismo_sigla, enero: 0, febrero: 0, marzo: 0, abril: 0, mayo: 0, junio: 0, julio: 0, agosto: 0, septiembre: 0, octubre: 0, noviembre: 0, diciembre: 0, monto: 0 });
      i++;
    });
    this.detalle = {
      id: 0,
      fecha_inicio: '',
      fecha_fin: '',
      unidad_ejecutora_id: 0,
      partida_presupuestaria_id: 0,
      descripcion_partida: '',
      cantidad: 0,
      unidad_medida_id: 0,
      precio_unitario: 0,
      tarea_id: 0,
      operacion_id: 0,
      accion_especifica_id: 0,
      total: 0,
      fuentes: f,
      justificacion_partida_presupuestaria: '',
      escala_salarial_id: 0,
      perfil: '',
      cargo: '',
      numero_items: 0,
      objetivo: '',
      actividades: '',
      resultados: '',
    };
  }

  
  saveTareaDetalle() {
    this.resetErrors();
    this.detalle.operacion_id = this.op_id;
    if (this.validSavePresupuesto() && this.validMonto()) {
      this.clicked = true;
      if (this.editDetalle) {

        this._ts.putTareaDetalle(this.detalle).subscribe(
          response => {
            let result = UtilHelper.responses(response);
            if (result.status == 200) {

              toastr.success('Presupuesto guardado correctamente.');
              this.refreshDataGrid();
              this.hideModalDT();
              this.clicked = false;
            }
          },
          (error) => { console.log('Error', error); });
      }
      else {
        if (this.rol == 23) {
          this.excedeTotal = false;
          this.detalle.operacion_id = this.operacionId;
          this.detalle.accion_especifica_id = this.accionEspId;
          this._ts.postTareaDetalle(this.detalle).subscribe(
            response => {
              let result = UtilHelper.responses(response);
              if (result.status == 200) {
                toastr.success('Presupuesto guardado correctamente.');
                this.refreshDataGrid();
                this.hideModalDT();
                this.clicked = false;
              }
            });
        }
        else {
          this._ts.getSumaMontosByTecho({ id: this.techoId, monto: this.detalle.total }).subscribe(
            (response) => {
              let result = UtilHelper.responses(response);
              if (result.status == 200) {
                if (result.data.estado == false) {
                  toastr.warning('Sobrepasó el monto total del techo presupuestario. El monto máximo a ingresar debe ser de: Bs ' + result.data.diferencia);
                  this.excedeTotal = true;
                  this.clicked = false;
                }
                else {
                  this.excedeTotal = false;
                  this.detalle.operacion_id = this.operacionId;
                  this.detalle.accion_especifica_id = this.accionEspId;
                  this._ts.postTareaDetalle(this.detalle).subscribe(
                    response => {
                      let result = UtilHelper.responses(response);
                      if (result.status == 200) {
                        toastr.success('Presupuesto guardado correctamente.');
                        this.refreshDataGrid();
                        this.hideModalDT();
                        this.clicked = false;
                      }
                    },
                    (error) => { console.log('Error', error); });
                }
              }
            });
        }
      }
    }
  }

  refreshDataGrid() {
    this.changeOperaciones(this.operacionId.toString());
    this.dataGrid.instance.refresh();
  }

  resetErrors() {
    this.hasError = { unidad_ejecutora_id: false, partida_presupuestaria_id: false, descripcion_partida: false, justificacion_partida_presupuestaria: false, cantidad: false, unidad_medida_id: false, precio_unitario: false, tarea_id: false, total: false, numero_items: false, actividades: false, producto: false, objetivo: false, resultado: false, cargo: false, perfil: false };
  }

  validSavePresupuesto() {
    let res = true;
    if (!this.editDetalle) {
      if (!UtilHelper.validator(this.detalle.tarea_id, 'integer') || this.detalle.tarea_id == 0) {
        this.hasError.tarea_id = true; res = false;
      }
    }
    if (!UtilHelper.validator(this.detalle.partida_presupuestaria_id, 'integer') || this.detalle.partida_presupuestaria_id == 0) {
      this.hasError.partida_presupuestaria_id = true; res = false;
    }
    if (!UtilHelper.validator(this.detalle.descripcion_partida, 'text')) {
      this.hasError.descripcion_partida = true; res = false;
    }
    if (!UtilHelper.validator(this.detalle.cantidad, 'number')) {
      this.hasError.cantidad = true; res = false;
    }
    if (!UtilHelper.validator(this.detalle.unidad_medida_id, 'integer') || this.detalle.unidad_medida_id == 0) {
      this.hasError.unidad_medida_id = true; res = false;
    }
    if (!UtilHelper.validator(this.detalle.precio_unitario, 'number')) {
      this.hasError.precio_unitario = true; res = false;
    }
    if (!UtilHelper.validator(this.detalle.total, 'number')) {
      this.hasError.total = true; res = false;
    }
    if ((!UtilHelper.validator(this.detalle.justificacion_partida_presupuestaria, 'text')) || (this.detalle.justificacion_partida_presupuestaria == null)) {
      this.hasError.justificacion_partida_presupuestaria = true; res = false;
    }


   

    return res;
  }

  validMonto() {
    let t = 0;
    for (var i = 0; i < this.detalle.fuentes.length; i++) {
      t += parseFloat(this.detalle.fuentes[i].monto);
    }
    if (Number(t.toFixed(2)) != this.detalle.total) {
      toastr.warning('La suma total del presupuesto debe ser igual al monto total.');
      return false;
    }

    


    return true;
  }

  showModalDelDT(id: number) {
    this.detalleId = id;
    this.popupVisibleDel = true;
  }

  deleteTareaDetalle() {
    this._ts.deleteTareaDetalle(this.detalleId).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.refreshDataGrid();
          this.popupVisibleDel = false;
          toastr.success('Operación realizada exitosamente.');
        } else {
          toastr.warning('Ocurrió un inconveniente al realizar la operación.');
        }
      },
      error => { console.log('Error', error); });
  }

  showModalEditTarea(id: number) {
    this.tareaId = id;
    this.popupVisibleETA = true;
  }

  showModalDelT(id: number) {
    this.tareaId = id;
    this.popupVisibleDelT = true;
  }

  saveTareaEdit(id: number, operacion_id: number) {
    let d = this.tareasList.filter(o => o.id == id).map(o => o.descripcion)[0];
    this._tt.putTarea({ id: id, descripcion: d, operacion_id: operacion_id }).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          toastr.success('Tarea/Actividad modificada correctamente.');
          this.refreshDataGrid();
          this.popupVisibleETA = false;
        }
        else if (result.status == 210) {
          toastr.success('No es posible modificar los datos debido a que existen registros de ejecución.');
        }
      },
      (error) => { console.log('Error', error); });
  }

  deleteTarea() {
    this._tt.deleteTarea(this.tareaId).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.refreshDataGrid();
          this.popupVisibleDelT = false;
          this.popupVisibleETA = false;
          this.getTareasByOperacionId();
          toastr.success('Operación realizada exitosamente.');
        }
        else if (result.status == 201) {
          toastr.warning('La Tarea/Actividad tiene presupuesto creado, para continuar primero se debe eliminar éstos elementos.');
        }
        else if (result.status == 210) {
          toastr.success('No es posible eliminar la Tarea/Actividad debido a que existen registros de ejecución.');
        }
        else {
          toastr.warning('Ocurrió un inconveniente al realizar la operación.');
        }
      },
      error => { console.log('Error', error); });
  }

  calculaMonto() {
    this.excedeTotal = false;
    if (this.rol != 23) {
      this._ts.getSumaMontosByTecho({ id: this.techoId, monto: this.detalle.total }).subscribe(
        (response) => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            if (result.data.estado == false) {
              toastr.warning('Sobrepasó el monto total del techo presupuestario. El monto máximo a ingresar debe ser de: Bs ' + result.data.diferencia);
              this.excedeTotal = true;
            }
            else {
              this.excedeTotal = false;
            }
          }
        },
        (error) => { console.log('Error', error); });
    }
  }

  showModalEditFP(id) {
    this.detalle.tarea_id = id;
    this.hasError.tarea_id = false;
    this._ts.getTareaDetalleFinanciadorById(id).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.dataTDF = result.data;
        }
      },
      (error) => { console.log('Error', error); });
    this.popupVisibleEPD = true;
  }

  saveEditTDF() {
    this.resetErrors2();
    if (this.validSaveTDF()) {
      this._ts.postTareaDetalleFinanciador(this.dataTDF).subscribe(
        response => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            toastr.success('Datos modificados correctamente.');
            this.refreshDataGrid();
            this.popupVisibleEPD = false;
          }
          else if (result.status == 210) {
            toastr.warning(result.data);
          }
        },
        (error) => { console.log('Error', error); });
    }
  }

  calcFuen() {
    this.excedeTotal = false;
    let m1 = this.dataTDF.enero != '' ? parseFloat(this.dataTDF.enero) : 0;
    let m2 = this.dataTDF.febrero != '' ? parseFloat(this.dataTDF.febrero) : 0;
    let m3 = this.dataTDF.marzo != '' ? parseFloat(this.dataTDF.marzo) : 0;
    let m4 = this.dataTDF.abril != '' ? parseFloat(this.dataTDF.abril) : 0;
    let m5 = this.dataTDF.mayo != '' ? parseFloat(this.dataTDF.mayo) : 0;
    let m6 = this.dataTDF.junio != '' ? parseFloat(this.dataTDF.junio) : 0;
    let m7 = this.dataTDF.julio != '' ? parseFloat(this.dataTDF.julio) : 0;
    let m8 = this.dataTDF.agosto != '' ? parseFloat(this.dataTDF.agosto) : 0;
    let m9 = this.dataTDF.septiembre != '' ? parseFloat(this.dataTDF.septiembre) : 0;
    let m10 = this.dataTDF.octubre != '' ? parseFloat(this.dataTDF.octubre) : 0;
    let m11 = this.dataTDF.noviembre != '' ? parseFloat(this.dataTDF.noviembre) : 0;
    let m12 = this.dataTDF.diciembre != '' ? parseFloat(this.dataTDF.diciembre) : 0;
    let t = m1 + m2 + m3 + m4 + m5 + m6 + m7 + m8 + m9 + m10 + m11 + m12;
    this.dataTDF.monto = t;
    if (Number(t.toFixed(2)) > parseFloat(this.dataTDF.total)) {
      this.excedeTotal = true;
      toastr.warning('Sobrepasó el total del presupuesto de la tarea.');
    }
  }

  validSaveTDF() {
    let res = true;
    if (!UtilHelper.validator(this.dataTDF.justificacion, 'text')) {
      this.hasError2.justificacion = true; res = false;
    }
    if (!UtilHelper.validator(this.dataTDF.cantidad, 'number')) {
      this.hasError2.cantidad = true; res = false;
    }
    if (!UtilHelper.validator(this.dataTDF.precio_unitario, 'number')) {
      this.hasError2.precio_unitario = true; res = false;
    }
    if (!UtilHelper.validator(this.dataTDF.total, 'number')) {
      this.hasError2.total = true; res = false;
    }
    if (parseFloat(this.dataTDF.monto) != parseFloat(this.dataTDF.total)) {
      toastr.warning('La suma de los montos debe ser igual al total.');
      res = false;
    }
    return res;
  }

  resetErrors2() {
    this.hasError2 = { justificacion: false, cantidad: false, unidad_medida_id: false, precio_unitario: false, total: false };
  }

  calculaCantidad2() {

    let t = this.dataTDF.total == '' ? '0' : this.dataTDF.total;
    let p = this.dataTDF.precio_unitario == '' ? '1' : this.dataTDF.precio_unitario;
    this.dataTDF.cantidad = (parseFloat(t) / parseFloat(p)).toFixed(1);
  }

  getFuentes() {
    this._fs.getFuente().subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.dataFuentes = result.data;
        } else {
          this.dataFuentes = [];
        }
      });
  }

  getOrganismos() {
    this._oo.getOrganismo().subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.dataOrganismos = result.data;
        } else {
          this.dataOrganismos = [];
        }
      });
  }

  calculaCantidad3() {
    let t = this.modelAFP.total;
    let p = this.modelAFP.precio_unitario == '' ? '1' : this.modelAFP.precio_unitario;
    this.modelAFP.cantidad = (parseFloat(t) / parseFloat(p)).toFixed(1);
  }

  calcFuen3() {
    this.excedeTotal = false;
    let m1 = this.modelAFP.enero != '' ? parseFloat(this.modelAFP.enero) : 0;
    let m2 = this.modelAFP.febrero != '' ? parseFloat(this.modelAFP.febrero) : 0;
    let m3 = this.modelAFP.marzo != '' ? parseFloat(this.modelAFP.marzo) : 0;
    let m4 = this.modelAFP.abril != '' ? parseFloat(this.modelAFP.abril) : 0;
    let m5 = this.modelAFP.mayo != '' ? parseFloat(this.modelAFP.mayo) : 0;
    let m6 = this.modelAFP.junio != '' ? parseFloat(this.modelAFP.junio) : 0;
    let m7 = this.modelAFP.julio != '' ? parseFloat(this.modelAFP.julio) : 0;
    let m8 = this.modelAFP.agosto != '' ? parseFloat(this.modelAFP.agosto) : 0;
    let m9 = this.modelAFP.septiembre != '' ? parseFloat(this.modelAFP.septiembre) : 0;
    let m10 = this.modelAFP.octubre != '' ? parseFloat(this.modelAFP.octubre) : 0;
    let m11 = this.modelAFP.noviembre != '' ? parseFloat(this.modelAFP.noviembre) : 0;
    let m12 = this.modelAFP.diciembre != '' ? parseFloat(this.modelAFP.diciembre) : 0;
    let t = m1 + m2 + m3 + m4 + m5 + m6 + m7 + m8 + m9 + m10 + m11 + m12;
    this.modelAFP.monto = t;
    if (Number(t.toFixed(2)) > parseFloat(this.modelAFP.total)) {
      this.excedeTotal = true;
      toastr.warning('Sobrepasó el total del presupuesto de la tarea.');
    }
  }

  resetErrors3() {
    this.hasError3 = { justificacion: false, cantidad: false, fuente_id: false, organismo_id: false, precio_unitario: false, total: false };
  }

  resetModel() {
    this.modelAFP = {
      id: 0, fuente_id: 0, organismo_id: 0, monto: 0, total: 0,
      enero: 0, febrero: 0, marzo: 0, abril: 0, mayo: 0, junio: 0, julio: 0, agosto: 0, septiembre: 0, octubre: 0, noviembre: 0, diciembre: 0,
      precio_unitario: 1, cantidad: 0, justificacion: ''
    };
  }

  saveAFP() {
    this.resetErrors3();
    if (this.validSaveAFP()) {
      this._ts.postAdicionaTareaDetalleFinanciador(this.modelAFP).subscribe(
        response => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            toastr.success('Fuente adicionada correctamente.');
            this.refreshDataGrid();
            this.popupVisibleAFP = false;
          }
        },
        (error) => { console.log('Error', error); });
    }
  }

  validSaveAFP() {
    let res = true;
    if (this.modelAFP.fuente_id == 0) {
      this.hasError3.fuente_id = true; res = false;
    }
    if (this.modelAFP.organismo_id == 0) {
      this.hasError3.organismo_id = true; res = false;
    }
    if (!UtilHelper.validator(this.modelAFP.justificacion, 'text')) {
      this.hasError3.justificacion = true; res = false;
    }
    if (!UtilHelper.validator(this.modelAFP.cantidad, 'number')) {
      this.hasError3.cantidad = true; res = false;
    }
    if (!UtilHelper.validator(this.modelAFP.precio_unitario, 'number')) {
      this.hasError3.precio_unitario = true; res = false;
    }
    if (!UtilHelper.validator(this.modelAFP.total, 'number')) {
      this.hasError3.total = true; res = false;
    }
    if (parseFloat(this.modelAFP.monto) != parseFloat(this.modelAFP.total)) {
      toastr.warning('La suma de los montos debe ser igual al total.');
      res = false;
    }
    return res;
  }

  showModalEditPartida(id: number, text: string) {
    this.textPartida = text;
    this.textPartidaId = id;
    this.popupVisibleP = true;
  }

  saveTextPartida() {
    if (this.textPartida.trim() != '') {
      this._ts.putDescripcionPartida({ id: this.textPartidaId, descripcion: this.textPartida }).subscribe(
        response => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            toastr.success('Descripción y/o justificación de la partida modificada correctamente.');
            this.refreshDataGrid();
            this.popupVisibleP = false;
          }
        },
        (error) => { console.log('Error', error); });
    }
  }

  getDisplayCod(item) {
    if (!item) {
      return '';
    }

    return `${item.codigo} ${item.titulo}`;
  }

  getDisplayCodEscala(item) {
    if (!item) {
      return '';
    }

    return `${item.denominacion} ${item.salario}`;
  }

  getCodigoPartida() {
    let existe = this.ArrayPartidaConsultoriasP.includes(this.detalle.partida_presupuestaria_id);
    let existe2 = this.ArrayPartidaConsultoriasL.includes(this.detalle.partida_presupuestaria_id);
    if (existe == true) {

      this.esConsultor = true;
      this.esConsultorL = false;
      this.detalle.unidad_medida_id = 14;
    }
    else if (existe2 == true) {

      this.esConsultor = true;
      this.esConsultorL = true;
      this._gs.getEscalaSalarialActivos().subscribe(
        response => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.escalas = result.data;
          }
        },
        (error) => { console.log('Error', error); });
    }
    else {
      this.esConsultor = false;
      this.detalle.escala_salarial_id = 0;
      this.detalle.objetivo = '';
      this.detalle.actividades = '';
      this.detalle.resultados = '';
      this.detalle.numero_items = 0;
      this.detalle.cargo = '';
      this.detalle.perfil = '';
    }
  }

  getEscalaSalarial(e: any) {

    this.escalas.forEach(item => {
      if (item.id == e.value) {
        this.detalle.unidad_medida_id = item.unidad_medida_id;
        this.detalle.precio_unitario = item.salario;
      }
    });
  }




  showModalProgramacion() {

    this.popupProgramacion = true;
    this.insert = true;
    this.newModel();
  }

  newModel() {
    this.insert = true;
    this.programacionTarea = {
      id: 0,
      tarea_id: 0,
      enero: '',
      febrero: '',
      marzo: '',
      abril: '',
      mayo: '',
      junio: '',
      julio: '',
      agosto: '',
      septiembre: '',
      octubre: '',
      noviembre: '',
      diciembre: '',
    }
  }

  getProgramacionTarea(e: any) {    
    this.tareaId = e.value;
    this._tt.getProgramacionTarea(e.value)
      .subscribe(
        response => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {            
            this.programacionTarea = result.data[0];
            this.insert = false;
            this.programacionTarea.id = result.data[0].id;
          }
        },
        (error) => { console.log('Error', error); });
  }


  saveProgramacion() {
    this.programacionTarea.tarea_id = this.tareaId;    
    if (this.insert == true) {
      this._tt.postProgramacionTarea(this.programacionTarea).subscribe(
        response => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {

            toastr.success('Programación guardada correctamente.');
            this.refreshDataGrid();
            this.popupProgramacion = false;
            this.clicked = false;
          }
          else {
            toastr.warning(result.data);
           

          }
        },
        (error) => { console.log('Error', error); });
    } else {
      this._tt.putProgramacionTarea(this.programacionTarea).subscribe(
        response => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {

            toastr.success('Programación guardada correctamente.');
            this.refreshDataGrid();
            this.popupProgramacion = false;
            this.clicked = false;
          }
          else {
            toastr.warning(result.data);
           

          }
        },
        (error) => { console.log('Error', error); });
    }
  }

}
